import { SocketCommand, socketManager } from "../../../components/AppProvider";

export const NativeViewOpen = (phoneOS, moveUrl) => {
  if (phoneOS === "ANDROID") {
    socketManager(SocketCommand.WEB_VIEW_OPEN, "", putJsonData(moveUrl));
  } else {
    socketManager(SocketCommand.WEB_VIEW_OPEN, "", putJsonData(moveUrl));
    // openLayerFn($("#alert-layer2"));
  }
};

export const putJsonData = moveUrl => {
  return {
    moveUrl: moveUrl,
  };
};
